import { NavigationTabs } from "../../../../../../components/NavigationTabs";
import { Button, useToast } from "@chakra-ui/react";
import categoryRegistry from "./categoryRegistry";
import { SCOPE_3_CATEGORIES_STEPS } from "./const";
import { useUpdateScopeThree } from "../../../../../../hooks/query/supplier-questionnaire/tabs";
import {
  CATEGORIES_NUM_KEYS,
  showErrorToast,
  showSuccessToast,
  SUPPLIER_QUESTIONNAIRE_TYPES
} from "../../../../../../utils";
import {
  supplierQuestionnaireKeys,
  useDefaultSupplierQuestionnaireConfig,
  useFinalizeSupplierQuestionnaire
} from "../../../../../../hooks/query";
import { hideAppSpinner, showAppSpinner } from "../../../../../../context/Store/slices/appSpinnerSlice";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "react-query";
import { COMPONENT_TYPES, CUSTOM_HEADER_ATTRS } from "./index";

function mapData(categories, t, questionnaireType, questionnaireId, isPreview, consumptionBasedData, isReviewModalUsed) {
  const elements = [];
  const componentType = questionnaireType === SUPPLIER_QUESTIONNAIRE_TYPES.EMISSION_BASED ?
    COMPONENT_TYPES.EMISSION_BASED : (!isPreview || (isPreview && !isReviewModalUsed)) ?
      COMPONENT_TYPES.CONSUMPTION_BASED : COMPONENT_TYPES.CONSUMPTION_BASED_PREVIEW;

  if (Object.keys(categories).length === 0) {
    CATEGORIES_NUM_KEYS.forEach(el => {
      categories[`category${el}`] = {};
    });
  }

  Object.keys(categories).forEach(key => {
    elements.push({
      component: categoryRegistry.resolve(key)[componentType] ?? categoryRegistry.resolve(key)[COMPONENT_TYPES.EMISSION_BASED],
      data: {
        ...categories[key],
        questionnaireId,
        consumptionBasedData,
        isReviewModalUsed
      },
      id: key,
      name: `Category ${SCOPE_3_CATEGORIES_STEPS.indexOf(key) + 1}`,
      subtitle: t(`supplierQuestionnaire.scopeThree.categories.${key}.name`),
      description: t(`supplierQuestionnaire.scopeThree.categories.${key}.description`, { defaultValue: "" }),
      customTabPanelTitle: `Category ${SCOPE_3_CATEGORIES_STEPS.indexOf(key) + 1}: ${t(`supplierQuestionnaire.scopeThree.categories.${key}.name`)}`,
      CustomHeaderComponent: !isPreview && questionnaireType === SUPPLIER_QUESTIONNAIRE_TYPES.CONSUMPTION_BASED ?
        categoryRegistry.resolve(key)[COMPONENT_TYPES.CUSTOM_HEADER]?.[CUSTOM_HEADER_ATTRS.COMPONENT] : null,
      customHeaderProps: !isPreview && questionnaireType === SUPPLIER_QUESTIONNAIRE_TYPES.CONSUMPTION_BASED ?
        categoryRegistry.resolve(key)[COMPONENT_TYPES.CUSTOM_HEADER]?.[CUSTOM_HEADER_ATTRS.PROPS] : null
    });
  });
  return elements;
}

function ScopeThree({
                      id: questionnaireId,
                      categories,
                      consumptionBasedData,
                      questionnaireType,
                      isReviewModalUsed,
                      handleTabChange,
                      isPreview,
                      isTabActive,
                      returnToListRequested,
                      returnToList
                    }) {
  const { t } = useTranslation("translation");
  const categoryElements = mapData(categories, t, questionnaireType, questionnaireId,
    isPreview, consumptionBasedData, isReviewModalUsed);

  const toast = useToast();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const changeTab = () => {
    handleTabChange(prev => prev - 1);
  };

  const { mutate: update, isLoading: isLoadingOnUpdate } = useUpdateScopeThree();
  const { mutate: finalize } = useFinalizeSupplierQuestionnaire({
    ...useDefaultSupplierQuestionnaireConfig(),
    onSuccess: () => {
      showSuccessToast(toast, t("supplierQuestionnaire.page.finalized"));
      returnToList();
    },
    onError: err => {
      showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message);
    }
  });

  useEffect(() => {
    if (isLoadingOnUpdate) {
      dispatch(showAppSpinner());
    }
  }, [dispatch, isLoadingOnUpdate]);

  const checkForFinalizeAndNavigation = (isFinalize, shouldChangeTab) => {
    if (isFinalize) {
      finalize(questionnaireId);
    } else if (returnToListRequested === true) {
      returnToList();
    } else if (shouldChangeTab) {
      changeTab();
    }
  };

  const saveMethod = (data, isFinalize, shouldChangeTab) => {
    if (data) {
      categories[data.categoryKey] = data;

      update({ questionnaireId, data: categories }, {
        onSuccess: () => {
          if (isFinalize) {
            finalize(questionnaireId);
          } else {
            showSuccessToast(toast, t("entitySaved", { entityName: t("supplierQuestionnaire.scopeThree.entityName") }));
            queryClient.invalidateQueries(supplierQuestionnaireKeys.supplierQuestionnaireById());
            if (returnToListRequested === true) {
              returnToList();
            }
            if (!isLoadingOnUpdate && shouldChangeTab) {
              changeTab();
            }
          }
        },
        onError: err => showErrorToast(toast, err.message),
        onSettled: () => dispatch(hideAppSpinner())
      });
    } else {
      checkForFinalizeAndNavigation(isFinalize, shouldChangeTab);
    }
  };

  return (
    <NavigationTabs
      elements={categoryElements}
      tabTitle={"Category"}
      subTitleAttribute={"subtitle"}
      saveMethod={isPreview ? null : saveMethod}
      formSubmission={{
        allowed: isTabActive,
        requested: returnToListRequested
      }}
      customNavButton={isPreview ? null : <Button
        colorScheme="white"
        color="esg_lightgreen"
        border={"1px solid"}
        borderColor={"esg_lightgreen"}
        type="submit"
        width="32"
      >
        {t("buttons.previous")}
      </Button>}
    />
  );
}

export default ScopeThree;